export const CREATE_TASK_TIMEOUT_MS = 120000;

export function emitWhenConnected(socket, emitFn) {
  if (!socket) return;
  if (socket.connected) {
    emitFn();
  } else {
    socket.once('connect', emitFn);
  }
}
